import axios from 'axios'      //在index.js中插入axios

let loading

function startLoading() {
loading = Loading.service({
lock: true,
text: '加载中……',
background: 'rgba(0, 0, 0, 0)'
})
}

function endLoading() {
loading.close()
}

let needLoadingRequestCount = 0
export function showFullScreenLoading() {
if (needLoadingRequestCount === 0) {
startLoading()
}
needLoadingRequestCount++
}

export function tryHideFullScreenLoading() {
if (needLoadingRequestCount <= 0) return
needLoadingRequestCount--
if (needLoadingRequestCount === 0) {
endLoading()
}
}
// 创建axios实例
const service = axios.create({
timeout: 180000
})

// request拦截器, 添加请求拦截器(request指拦截请求)
service.interceptors.request.use(config => {
// Do something before request is sent
// if (config.loading !== false) {
// showFullScreenLoading()
// }
return config   
}, error => {
// Do something with request error
console.log(error) // for debug
return
})
service.interceptors.request.use(config=>{
return config
},
error=>{
  console.log(error)
  return
})

//  http respone指的是响应信息
service.interceptors.response.use(res => {
// let res = response
// if (res) {
// if (res.code === 4002) {
// sessionStorage.setItem('sessionId', '')
// window.location.href = '/index.html';
// }
// if (res.flag == false) {
// Message({
// center: true,
// message: res.msg,
// type: 'error'
// });
// }
// }
// tryHideFullScreenLoading()
// console.log(response)
return res 
},
error => {
// endLoading()
console.log('err' + error)// for debug
return
})

export default service   //导出axios


// WEBPACK FOOTER //
// ./src/utils/index.js